import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	TabContent, TabPane, Nav, NavItem, NavLink
} from 'reactstrap';
import classnames from 'classnames';
import RichTextEditor from 'react-rte';
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';

class Circular extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			id: '',
			cirsub: '',
			refno: '',
			value: RichTextEditor.createEmptyValue(),
			cirdate: '',
			attach: '',
			_message: '',
			alertClass: '',
			posts: [],
			data: [],
			activeTab: '1'
		}

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.toggle = this.toggle.bind(this);
		this.onClick = this.onClick.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	toggle(tab) {
		if (this.state.activeTab !== tab) {
			this.setState({
				activeTab: tab
			});
		}
	}

	/** reset Subject Allocated form **/
	onClick(e) {

		document.getElementById("cirform").reset();
	}

	/** set value **/
	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
		// console.log(this.state);
	}

	/** set value to react-html editor content **/
	handleChange(value) {

		this.setState({ value });
		this.setState({ content: this.state.value.toString('html') });
	}

	onSubmit(e) {
		e.preventDefault();

		if (this.state.cirsub && this.state.refno && this.state.cirdate) {
			$("#showLoader").show();
			PostData('academic/addcircular', this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if (responseJson.status == '1') {
					this.setState({
						_message: 'Circular Details added Successfully!..',
						alertClass: 'alert alert-success',
					});
					document.getElementById("cirform").reset();
					this.getdata();
				}
				else {

					this.setState({
						_message: 'Invalid Key',
						alertClass: 'alert alert-danger'
					});
				}
			});

		}

	}

	/** this function will be call when page loading **/
	componentWillMount() {

		this.getdata();
	}

	getdata() {
		$("#showLoader").show();
		GetData('academic/getcircular').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					data: responseJson
				});
			}
		});
	}

	handleClick(dd) {

		this.state.id = dd;
		console.log('id' + this.state.id);

		if (window.confirm("Do you want to Delete?")) {
			$("#showLoader").show();
			PostData('academic/deletelesplan', this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if (responseJson.status == '1') {
					this.setState({
						_message: 'LessonPlanning Removed Successfullly',
						alertClass: 'alert alert-success'
					});
					this.getdata();
				}
				else {

					this.setState({
						_message: 'Error in Remove LessonPlanning',
						alertClass: 'alert alert-danger'
					});
				}
			});
		}
	}


	render() {

		var items = this.state.posts;

		return (
			<div>
				<AcademicPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						<Col md="12">
							<Nav tabs>
								<NavItem>
									<NavLink
										className={classnames({ active: this.state.activeTab === '1' })}
										onClick={() => { this.toggle('1'); }}
									>
										Circular Details
					</NavLink>
								</NavItem>
								<NavItem>
									<NavLink
										className={classnames({ active: this.state.activeTab === '2' })}
										onClick={() => { this.toggle('2'); }}
									>
										List
					</NavLink>
								</NavItem>
							</Nav>
							<TabContent activeTab={this.state.activeTab}>
								<TabPane tabId="1">
									<Row>
										<Col md="12">
											<Card>
												<form action="" method="post" role="form" id="cirform" encType="multipart/form-data" onSubmit={this.onSubmit} >
													<CardHeader>
														<strong>Circular Details</strong>
													</CardHeader>
													<CardBody>
														<Row>
															<Col md="12">
																<FormGroup>
																	<Label htmlFor="name">Circular Subject <span className="text-danger">*</span></Label>
																	<Input type="text" name="cirsub" required onChange={this.onChange} />
																</FormGroup>
															</Col>
															<Col md="12">
																<FormGroup>
																	<Label htmlFor="name">Reference No. <span className="text-danger">*</span></Label>
																	<Input type="text" name="refno" required onChange={this.onChange} />
																</FormGroup>
															</Col>
															<Col md="12">
																<FormGroup>
																	<Label htmlFor="name">Circular Contents <span className="text-danger">*</span></Label>
																	<RichTextEditor value={this.state.value} onChange={this.handleChange} />
																</FormGroup>
															</Col>
															<Col md="12">
																<FormGroup>
																	<Label htmlFor="name">Circular Date <span className="text-danger">*</span></Label>
																	<Input type="date" name="cirdate" required onChange={this.onChange} />
																</FormGroup>
															</Col>
															{/*<Col md="12">
																<FormGroup>
																	<Label htmlFor="name">Add Attachment </Label>
																	<Input type="file" name="attach" onChange={this.onChange} />
																</FormGroup>
															</Col>*/}
														</Row>
													</CardBody>
													<CardFooter>
														<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
														<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
													</CardFooter>
												</form>
											</Card>
										</Col>
									</Row>
								</TabPane>
								<TabPane tabId="2">
									<Row>
										<Col md="12">
											<Table responsive bordered>
												<thead>
													<tr>
														<th>S.No</th>
														<th>Circular Subject</th>
														<th>Reference No</th>
														<th>Date</th>
														<th>Manage</th>
													</tr>
												</thead>
												<tbody>
													{this.state.data.map(item =>

														<tr key={item}>
															<td>{item.id}</td>
															<td>{item.circularsubject}</td>
															<td>{item.refno}</td>
															<td>{item.circulardate}</td>
															<td>
																<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
															</td>
														</tr>

													)}
												</tbody>
											</Table>
										</Col>
									</Row>
								</TabPane>
							</TabContent>
						</Col>
					</Row>
				</div>
			</div>
		);
	}
}

export default Circular;


// WEBPACK FOOTER //
// ./src/circular/Circular/Circular.js